import { render, staticRenderFns } from "./UserChangeAvatar.vue?vue&type=template&id=0109b7ea&"
import script from "./UserChangeAvatar.vue?vue&type=script&lang=js&"
export * from "./UserChangeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserChangeAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports